import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
} from '@angular/core';
import { ChangeLanguage } from '@rivethealth/data/analytics/patient-analytics-events';
import { sentenceCase } from '@rivethealth/data/capitalization';
import { Loadable, merge } from '../../common/helpers/loadable';
import { TranslatePipe } from '../../common/translation/translate.pipe';
import { TranslationService } from '../../common/translation/translation.service';
import { PatientAnalyticsService } from '../patient-facing-estimation/patient-analytics.service';

@Component({
  host: { class: 'rv-grow rv-rows rv-scrollable fill' },
  selector: 'patient-card',
  templateUrl: './patient-card.component.html',
  styleUrls: ['./patient-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PatientCardComponent implements OnDestroy {
  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly translationService: TranslationService,
    private readonly patientAnalyticsSerice: PatientAnalyticsService,
  ) {}
  ngOnDestroy(): void {
    this.translatePipe.ngOnDestroy();
  }
  private translatePipe = new TranslatePipe(this.cdr, this.translationService);

  @Input() loadableData: Loadable<any> | Loadable<any>[];
  @Input() logoUrl: string;
  @Input() includeLanguageChange: boolean = true;
  @Input() xlarge: boolean = true;

  showLogo = true;

  changeLang() {
    const lang = this.translationService.lang.value == 'en' ? 'es' : 'en';
    this.translationService.lang.next(lang);
    this.patientAnalyticsSerice.logEvent(ChangeLanguage, {
      language: sentenceCase(lang),
    });
  }

  get loadableData_() {
    const message = this.translatePipe.transform(
      'patientEstimate.estimateDeletedMessage',
    );
    const loadableData =
      this.loadableData instanceof Array
        ? merge(...this.loadableData)
        : this.loadableData;
    return { ...loadableData, error: message };
  }
}
